import deviceType = $deviceState.deviceType;
import { ScItem, ShortPhraseFields } from '@/types/sitecore';
import { RatioFields } from '@/types';
import utils from '@/utils/index';

export const adpRatio = (deviceType: string, ratioItem?: ScItem<RatioFields>) => {
  if (!ratioItem?.fields) return undefined;
  if (['mobile', 'tablet'].includes(deviceType))
    return utils.gs.getRatioVal(utils.sp.getVal(ratioItem.fields.mobileRatio));
  return utils.gs.getRatioVal(utils.sp.getVal(ratioItem.fields.desktopRatio));
};
